import { JqueryClassFaker } from './JqueryClassFaker';
import store from 'react/redux/store/store';

export default class MatchSearchFilterReasons {
	static IS_AUTO_QUEUE_ONLY = {
		className: 'hidden_by_auto_queue',
		reason: "This player only takes automatic matches and can't be challenged directly",
		hideWithCheatCode: true,
	};
	static DOUBLES_SETTING = {
		className: 'hidden_by_doubles',
		myFaultForRestrictiveness: false,
	};
	static CONTINENT_THEIR_SETTING = {
		className: 'hidden_by_continent',
		myFaultForRestrictiveness: false,
	};
	static LOCALITY_THEIR_SETTING = {
		className: 'hidden_by_locality',
		myFaultForRestrictiveness: false,
	};
	static STATE_THEIR_SETTING = {
		className: 'hidden_by_state',
		myFaultForRestrictiveness: false,
	};
	static COUNTRY_THEIR_SETTING = {
		className: 'hidden_by_country',
		myFaultForRestrictiveness: false,
	};
	static RATING_GAP_MY_SETTING = {
		className: 'hidden_by_rating_gap',
		myFaultForRestrictiveness: true,
		reason: 'Your rating gap setting is blocking matches from being shown',
	};
	static RATING_GAP_THEIR_SETTING = {
		className: 'hidden_by_rating_gap',
		myFaultForRestrictiveness: false,
		reason: "Your rating is outside this player's rating gap setting",
	};
	static REMATCH_COOLDOWN_MY_SETTING = {
		className: 'hidden_by_rematch_cooldown',
		myFaultForRestrictiveness: true,
		reason: 'Your rematch cooldown is hiding players you played recently',
	};
	static REMATCH_COOLDOWN_THEIR_SETTING = {
		className: 'hidden_by_rematch_cooldown',
		myFaultForRestrictiveness: false,
		reason: "You played this player too recently for their rematch cooldown",
	};
	static NO_GAME = {
		className: 'hidden_by_game',
	};

	constructor() {
		this.reasons = new Set();
		this.classList = new JqueryClassFaker();
		this.classListIsOutdated = false;
		this.shouldShowWithCheatCode = true;
	}

	all() {
		return this.reasons;
	}

	reset() {
		this.reasons.clear();
		this.shouldShowWithCheatCode = true;
		this.classListIsOutdated = true;
	}

	addSearchFailReason(reason, myFault = false) {
		this.classListIsOutdated = true;
		const failReason = new MatchSearchFilterReason(reason, myFault);
		if(reason.hideWithCheatCode) {
			this.shouldShowWithCheatCode = false;
		}
		this.reasons.add(failReason);
	}

	hasFailReasons() {
		if(!this.shouldShowWithCheatCode) {
			return true; // Hide anyway (This is a workaround for auto-queue searches to remain hidden until I fix it server side)
		}
		if(store.getState().settings.cheatCodeActivated) {
			return false;
		}
		return this.reasons.size > 0;
	}

}

class MatchSearchFilterReason {
	constructor(data, myFault) {
		this.isFault = myFault;
		this.data = data;
	}

	isMyFault() {
		return this.isFault || this.data.myFaultForRestrictiveness === true;
	}
}